import { call, put, takeEvery } from "redux-saga/effects";
import { getCall } from "../../../../helpers/fakebackend_helper";
import { verifyData } from "../../../../pages/Common/CommonFunctions/commonFunctions";
import { GET_ALL_SHORTLIST_DETAILS } from "./actionTypes";
import { getAllShortlistDetailsFail, getAllShortlistDetailsSuccess } from "./actions";
// Worker Saga: Makes the API call and dispatches success or failure actions
function* fetchShortlistDetails(data) {
  let requestData = data.payload;
  try {
    let url = "recruitment/shortlist/list";
    let pageNumeber = 0;
    let pageSize = 50;
    if (requestData !== undefined && requestData != null) {
      pageNumeber = requestData.pageNumber
        ? requestData.pageNumber
        : pageNumeber;
      pageSize = requestData.pageSize ? requestData.pageSize : pageSize;
    }
    url = url + `?page=${pageNumeber}&pageSize=${pageSize}`;
    if (requestData.sort !== null && requestData.sort !== undefined) {
      url = url + "&sort=" + encodeURIComponent(requestData.sort);
    }
    let extentedUrl;

    if (
      verifyData(requestData.filter) &&
      Object.entries(requestData?.filter).length > 0
    ) {
      extentedUrl = requestData.filter.map((eachObject) => {
        return (
          eachObject.filterName +
          "=" +
          encodeURIComponent(
            eachObject.condition + "[" + eachObject.value + "]"
          )
        );
      });
    }
    if (verifyData(requestData.searchKeyword)) {
      url = url + "&searchKeyword=" + requestData.searchKeyword;
    }
    if(extentedUrl !== undefined && extentedUrl !== null && extentedUrl !== ""){
        url = url+`&${extentedUrl.join("&") }`
      }
    
    const response = yield call(getCall, url);
    yield put(getAllShortlistDetailsSuccess(response));
  } catch (error) {
    
    yield put(getAllShortlistDetailsFail(error.message));
  }
}

function* shortlistDetailsSaga() {
  yield takeEvery(GET_ALL_SHORTLIST_DETAILS, fetchShortlistDetails);
}
export default shortlistDetailsSaga;
